export const PLACEMENTS_WORST_AUTODISABLE = 'placements_worst_autodisable'
export const PLACEMENTS_PERSONAL_BLACKLIST_ADD = 'placements_personal_blacklist_add'
export const PLACEMENTS_PERSONAL_BLACKLIST_DELETE = 'placements_personal_blacklist_delete'
export const PLACEMENTS_WHITELIST_ADD = 'placements_whitelist_add'
export const PLACEMENTS_WHITELIST_DELETE = 'placements_whitelist_delete'
export const PLACEMENTS_WHITELIST_SWITCH = 'placements_whitelist_switch'
export const PLACEMENTS_NETWORK_DISABLE = 'placements_network_disable'
export const PLACEMENTS_NETWORK_ENABLE = 'placements_network_enable'
